import type {PlaceId} from '@jetbrains/teamcity-ui'
import type {ReactNode} from 'react'

import usePluginWrapper from './usePluginWrapper'

type Props = {
  children: ReactNode
  placeId: PlaceId
}

function PluginWrapper({children, placeId}: Props) {
  const {hasPlugins} = usePluginWrapper(placeId)

  return hasPlugins ? children : null
}
export default PluginWrapper
